<script lang='ts'>
  import { onDestroy, onMount } from "svelte";

    export let showModal = false
    export let modalRight: boolean
    export let modalBottom: boolean
    export let modalCenterX: boolean = false

    let node

    const handleClick = (event) => {
        if (node && !node.contains(event.target) && !event.defaultPrevented) {
            event.preventDefault()
            event.stopPropagation()
            showModal = false
        }
    }

    onMount(() => {
        document.addEventListener('click', handleClick, true);
    })
    onDestroy(() => {
        document.removeEventListener('click', handleClick, true);
    })
</script>

{#if showModal}
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div on:click|stopPropagation bind:this={node} class='simpleModal' class:modalCenterX class:modalRight class:modalBottom>
        <slot />
    </div>
{/if}

<style lang='scss'>
    .simpleModal {
        --offset: var(--modal-offset, 5%);
        &.tight {
            --offset: 0px;
        }

        padding: 10px;
        background-color: white;
        border-radius: 10px;
        box-shadow: 0 0 15px #000000;
        position: absolute;
        left: var(--offset);
        top: var(--offset);
        z-index: 50;
        &.modalRight {
            left: unset;
            right: var(--offset);
        }
        &.modalCenterX {
            left: 50%;
            transform: translateX(-50%);
        }
        &.modalBottom {
            top: unset;
            bottom: var(--offset);
        }
    }
</style>